import styled from 'styled-components';

export const Cell = styled.span`
  font-variant-numeric: tabular-nums;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  justify-content: flex-end;
`;

export const NearText = styled.span`
  color: #b26b00;
  font-weight: 600;
`;

export const OverText = styled.span`
  color: #c0392b;
  font-weight: 600;
`;

export const MutedText = styled.span`
  color: rgba(0, 0, 0, 0.45);
`;
